export default {"src":"/_next/static/media/united_kingdom.c8a21f6d.svg","height":512,"width":512};